import gql from 'graphql-tag';
import React from 'react';
import TagManager from 'react-gtm-module';
import { useMutation } from 'react-apollo';

import { ActionItem, ActionList, closeModal, initModal, ModalContent, ModalFooter } from '../../../components/modal';
import Button from '../../../components/button';
import { PlayerCardOperator } from '../../../types';
import { WarningTriangle } from '../../../assets/icons';

export default function (props: Props) {
  initModal({
    actions: [],
    content: <ActivateCardComponent {...props} />,
    context: '',
    open: true,
    title: 'Rewards Card'
  });
}

export type Props = {
  cardIdentifier: { cardNumber: string; cardOperator: PlayerCardOperator };
  onActivated(): void;
};

export function ActivateCardComponent({ cardIdentifier, onActivated }: Props) {
  const [activateMutation, { loading }] = useMutation(activateMutationGraphql, {
    variables: { card: { number: cardIdentifier.cardNumber, operator: cardIdentifier.cardOperator } }
  });

  return loading ? (
    <>Activating Rewards Card</>
  ) : (
    <>
      <ModalContent withFooter={true}>
        <WarningTriangle />
        <p>Would you like to activate card number {cardIdentifier.cardNumber} ?</p>
      </ModalContent>
      <ModalFooter>
        <ActionList>
          <ActionItem>
            <Button className="qa-modal-cancel" modifiers="secondaryRound" onClick={() => closeModal()}>
              Cancel
            </Button>
          </ActionItem>
          <ActionItem>
            <Button className="qa-modal-activate" modifiers="primaryRound" onClick={() => activated()}>
              Activate
            </Button>
          </ActionItem>
        </ActionList>
      </ModalFooter>
    </>
  );

  async function activated() {
    await activateMutation();
    closeModal();
    onActivated();
    TagManager.dataLayer({
      dataLayer: { event: 'reward-card-activated' },
      dataLayerName: 'USROSI'
    });
  }
}

export const activateMutationGraphql = gql`
  mutation activate($card: CardWithOperatorInput!) {
    activate(card: $card) {
      id
    }
  }
`;
